module.exports = __webpack_public_path__ + "static/img/gift_card_popup.8c24b00.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/wordHunt/light/gift_card_popup.png
// module id = 3jg0
// module chunks = 1